import { ck, interact } from "fire-wind-water";
import service from "../service/form";
import { settingMeetingData } from "../common/settingData";
import * as sbaseData from "../common/sbase";
export default {
  data() {
    return {
      seminarInfo: {},
      posterInfo: {},
      posterUrl: "",
    };
  },
  methods: {
    /* 获取海报信息 */
    getPostInfo() {
      let param = {
        instanceId: sbaseData.instanceId,
        globalUserId: ck.cookie("globalUserId"),
        expandInfo: ["poster"],
      };
      service.getTopicTemplateSeminar(param).then((data) => {
        if (data.content) {
          this.posterInfo = data.content;
          this.posterUrl = `${window.location.protocol}${
            data.content.poster.wap ? data.content.poster.wap.formalUrl : ""
          }${data.content.weChatId || ""}&schemaId=${
            data.content.schemaId || 0
          }`;
          if (typeof this.getSignUpStatus === "function") {
            this.getSignUpStatus();
          }
        }
      });
    },

    /* 获取会议信息 */
    getEventInfo() {
      if (sbaseData.isSetting) {
        this.seminarInfo = settingMeetingData;
        return;
      }
      if (interact.isMobile) {
        this.getPostInfo();
      }
      let param = {
        instanceId: sbaseData.instanceId,
        globalUserId: ck.cookie("globalUserId"),
      };
      service.getTopicTemplateSeminar(param).then((data) => {
        if (data.content) {
          this.seminarInfo = data.content;
        }
      });
    },
  },
};
